var React = require('react');

function TwitterX (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"platforms"},React.createElement("path",{"id":"Vector","d":"M15.2716 1.6665H18.0828L11.9411 8.68608L19.1663 18.2381H13.509L9.07804 12.4449L4.00796 18.2381H1.19503L7.7642 10.7299L0.833008 1.6665H6.63393L10.6392 6.96178L15.2716 1.6665ZM14.2849 16.5555H15.8427L5.7875 3.26078H4.11589L14.2849 16.5555Z","fill":"#ADB5BD"})));
}

TwitterX.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = TwitterX;

TwitterX.default = TwitterX;
